const WorkflowsIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 18.61">
            <g id="Group_7903" data-name="Group 7903" transform="translate(0 0)">
                <g id="Group_7902" data-name="Group 7902" transform="translate(0 0)">
                    <path
                        id="Path_3372"
                        data-name="Path 3372"
                        d="M11.591,7.989a2.927,2.927,0,0,0-1.275.289,2.736,2.736,0,0,0-1.575,2.456,2.852,2.852,0,1,0,2.85-2.745Z"
                        transform="translate(4.97 4.543)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_3373"
                        data-name="Path 3373"
                        d="M7.321.375A2.949,2.949,0,0,0,6.046.664,2.738,2.738,0,0,0,4.471,3.12a2.8,2.8,0,0,0,2.85,2.745A2.8,2.8,0,0,0,10.173,3.12,2.8,2.8,0,0,0,7.321.375Z"
                        transform="translate(2.542 0.213)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_3374"
                        data-name="Path 3374"
                        d="M3.225,7.989a2.927,2.927,0,0,0-1.275.289A2.736,2.736,0,0,0,.375,10.734a2.8,2.8,0,0,0,2.85,2.745,2.747,2.747,0,1,0,0-5.49Z"
                        transform="translate(0.213 4.543)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_3375"
                        data-name="Path 3375"
                        d="M2.34,4.932a.413.413,0,0,0-.182.041.392.392,0,0,0-.226.351.408.408,0,1,0,.408-.392Z"
                        transform="translate(1.099 2.804)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_3376"
                        data-name="Path 3376"
                        d="M2.34,1.875a.413.413,0,0,0-.182.041.392.392,0,0,0-.226.351.408.408,0,1,0,.408-.392Z"
                        transform="translate(1.099 1.066)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_3377"
                        data-name="Path 3377"
                        d="M10.706,4.932a.413.413,0,0,0-.182.041.392.392,0,0,0-.226.351.408.408,0,1,0,.408-.392Z"
                        transform="translate(5.856 2.804)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_3378"
                        data-name="Path 3378"
                        d="M10.706,1.875a.413.413,0,0,0-.182.041.392.392,0,0,0-.226.351.408.408,0,1,0,.408-.392Z"
                        transform="translate(5.856 1.066)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_3379"
                        data-name="Path 3379"
                        d="M6.436,9.489a.418.418,0,0,0-.182.041.392.392,0,0,0-.226.351.409.409,0,1,0,.408-.392Z"
                        transform="translate(3.428 5.396)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_3380"
                        data-name="Path 3380"
                        d="M6.436,6.432a.418.418,0,0,0-.182.041.392.392,0,0,0-.226.351.409.409,0,1,0,.408-.392Z"
                        transform="translate(3.428 3.657)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                </g>
            </g>
        </svg>
    );
};

export default WorkflowsIcon;
